function ServerError(status) {
    this.stack = (new Error()).stack;
    this.status = status || 500;

    switch (this.status) {
        case 503:
            this.message = "Under maintenance, please try again in a little while.";
            break;

        default:
            this.message = "We're experiencing a problem. Please try again and if the problem persists, contact us at support@zeplin.io.";
    }
}

ServerError.prototype = Object.create(Error.prototype);
ServerError.prototype.name = "ServerError";

ServerError.prototype.toString = function () {
    return "(" + this.status + ") " + this.message;
};

export default ServerError;
